module.exports = __webpack_public_path__ + "static/media/marker.3cadeab8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/marker.svg
// module id = 583
// module chunks = 0